import * as esriLoader from 'esri-loader';

import { MapApi } from '../api/map-api';
import { environment } from '../environment';
import { LayerService } from '../services/layer.service';
import { IMapCoreMap, IMCMapView, IQuery } from '../types';

type MCMapViewConstructor = (esriProps: __esri.MapViewProperties, mapId: string, mapApi: MapApi, layerService: LayerService) => Promise<IMCMapView>;

interface IMCMapViewProperties extends __esri.MapViewProperties {
    // viewReady: Promise<boolean>;
    mapcoreViewProps?: IMapCoreMap;
}

class MapViewExtender {
    public static async construct() {
        const [mapView] = await esriLoader.loadModules(['esri/views/MapView'], window.esriConfig) as [__esri.MapViewConstructor];
        const MCMapView = async (esriProps, mapId, mapApi: MapApi, layerService: LayerService) => {
            const tempMapView = new mapView(esriProps) as IMCMapView;

            tempMapView.resetMapProps = function(map: IMapCoreMap = null) {
                this.map.removeAll();
                if (!map) {
                    map = {
                        description: '',
                        id: null,
                        isPublic: null,
                        isSystem: null,
                        name: 'New Map'
                    } as any;
                }
                this.mapcoreViewProps = { ...map };
                this.mapcoreViewProps.applicationID = environment.appId;
            };

            tempMapView.addMapcoreLayerToMap = function(layerId: number, query?: IQuery) {
                const layerSettings = { id: layerId, query: query ? query : null };
                layerService.addMapcoreLayersToMap([layerSettings]);
            };

            // TODO: Need to do some work on timing with API call and components that use map view before we can use map id
            if (mapId) {
                const result = await mapApi.getMaps(mapId);
                tempMapView.mapcoreViewProps = result[0];
                tempMapView.mapcoreViewProps.applicationID = environment.appId;
                tempMapView.container = esriProps.container;
                tempMapView.map = esriProps.map;
                tempMapView.ui = esriProps.ui;
                tempMapView.center = null; //map center from map
                tempMapView.zoom = null; //zoom from map
            } else {
                tempMapView.container = esriProps.container;
                tempMapView.map = esriProps.map;
                tempMapView.ui = esriProps.ui;
                tempMapView.center = esriProps.center;
                tempMapView.zoom = esriProps.zoom;
                tempMapView.resetMapProps();
            }

            return tempMapView;
        };
        return MCMapView as MCMapViewConstructor;
    }
}

export { MapViewExtender, IMCMapView, IMCMapViewProperties, MCMapViewConstructor };
